export const isPublicSellPriceMissing = (value: unknown): boolean => {
  if (value == null) {
    return true;
  }
  const text = String(value).trim();
  if (!text) {
    return true;
  }
  return /^n\/a$/i.test(text);
};

export const parsePublicPriceAmount = (value: unknown): number | null => {
  if (isPublicSellPriceMissing(value)) {
    return null;
  }
  const n = Number(String(value).replace(/,/g, "").trim());
  return Number.isFinite(n) ? n : null;
};

export const parseGstPercent = (value: unknown): number => {
  const n = Number(String(value ?? "").replace(/%/g, "").trim());
  return Number.isFinite(n) && n > 0 ? n : 0;
};

export const formatCatalogueRupees = (amount: number): string =>
  `₹${amount.toLocaleString("en-IN", {
    maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
  })}`;

/** Buyer-facing catalogue price: listed amount plus GST when a rate exists on the product. */
export const catalogueBuyerPriceCopy = (
  sellPrice: unknown,
  gstRate?: unknown
): { amount: string; label: string; detail: string } | null => {
  const amount = parsePublicPriceAmount(sellPrice);
  if (amount == null) {
    return null;
  }
  const gstPct = parseGstPercent(gstRate);
  if (gstPct > 0) {
    const gstAmt = (amount * gstPct) / 100;
    return {
      amount: formatCatalogueRupees(amount),
      label: "catalogue price",
      detail: `+ GST ${gstPct}% ${formatCatalogueRupees(gstAmt)} · ${formatCatalogueRupees(
        amount + gstAmt
      )} with GST`,
    };
  }
  return {
    amount: formatCatalogueRupees(amount),
    label: "catalogue price",
    detail: "+ GST extra",
  };
};
